import LOCALE from 'common/locale';

import { FileMimeType } from './types';

/**
 * This list represent the mimeTypes of:
 * - all PDF files,
 * - the types of image files Shine support.
 */
const ALLOWED_DOCUMENTS: FileMimeType[] = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/bmp',
];

const BULK_TRANSFERS_ALLOWED_DOCUMENTS: FileMimeType[] = [
  'text/csv',
  'application/xml',
  'text/xml',
];

export const FILE_TYPE = {
  ALLOWED_DOCUMENTS,
  BULK_TRANSFERS_ALLOWED_DOCUMENTS,
};

const getCapitalizedExtensionFromMimeType: (
  mimeType: FileMimeType,
) => string = (mimeType) =>
  mimeType.substr(mimeType.lastIndexOf('/') + 1).toUpperCase();

export const composeExtensionsDisjunction: (
  mimeTypes: FileMimeType[],
) => string = (mimeTypes: FileMimeType[]) => {
  const capitalizedExtensions = [
    ...new Set(mimeTypes.map(getCapitalizedExtensionFromMimeType)),
  ];
  return new Intl.ListFormat(LOCALE, { type: 'disjunction' }).format(
    capitalizedExtensions,
  );
};
